module.exports = __webpack_public_path__ + "static/media/curbside.c93c52af.png";